//@flow
import type { CountryType } from '../../../config/iddCountries';

export type RoamingActionType =
  | {|
      type: 'SET_ROAMING_COUNTRY',
      payload: {|
        country: CountryType,
      |},
    |}
  | {|
      type: 'SET_ROAMING_PACKAGE',
      payload: {|
        country: CountryType,
        comesFromDashboard: boolean,
      |},
    |}
  | {|
      type: 'BUY_ROAMING_PACKAGE',
    |};

export function setRoamingCountry(country: CountryType): RoamingActionType {
  return {
    type: 'SET_ROAMING_COUNTRY',
    payload: {
      country,
    },
  };
}

export function setRoamingPackage(country: CountryType, comesFromDashboard: boolean): RoamingActionType {
  return {
    type: 'SET_ROAMING_PACKAGE',
    payload: {
      country,
      comesFromDashboard,
    },
  };
}

export const buyRoamingPackage = (): RoamingActionType => ({
  type: 'BUY_ROAMING_PACKAGE',
});
